<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Banners' : 'Deleted Banners'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  @click="showCreateDialog = true"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Banner Name</th>
                      <th class="text-left" style="min-width: none">Banner Image</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="banners.length != 0">
                    <tr
                      v-for="(banner, i) in banners"
                      :key="`banner_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': banners.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="banner.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Banner is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="banner.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Banner is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ banner.title || "" }}
                      </td>
                      <td>
                        <v-btn
                          icon
                          text
                          :href="`${mediaUrl}${banner.image_path}`"
                          color="primary"
                          target="_blank"
                        >
                          <v-icon>mdi-file-document-edit-outline</v-icon>
                        </v-btn>
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(banner)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Banner</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openEditDialog(banner)"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Banner</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(banner.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this banner</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_banner" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Banner deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_banner = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_banner" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Banner restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_banner = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete Banner"
      message="This action cannot be undone."
      icon="mdi-delete"
      color="error"
      :loading="delete_banner"
      @confirm="Delete_this(pendingDeleteId)"
    >
      <template v-slot:details>
        <v-alert v-if="pendingDeleteBanner" outlined color="error" class="mt-3 mb-0" dense>
          <div class="d-flex align-center">
            <v-avatar tile size="48" class="mr-3" style="border-radius:6px">
              <v-img
                v-if="pendingDeleteBanner.image_path"
                :src="`${mediaUrl}${pendingDeleteBanner.image_path}`"
                cover
              ></v-img>
              <v-icon v-else color="error">mdi-image-off-outline</v-icon>
            </v-avatar>
            <div class="font-weight-bold">
              {{ pendingDeleteBanner.title || "Untitled banner" }}
            </div>
          </div>
        </v-alert>
      </template>
    </ConfirmationDialog>

    <!-- Add Banner -->
    <AppDialog
      :show.sync="showCreateDialog"
      max-width="700"
      persistent
      icon="mdi-view-carousel"
      title="Add Banner"
      subtitle="Create a promotional banner"
    >
      <BannerCreatePage
        v-if="showCreateDialog"
        embedded
        @created="onBannerCreated"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Edit Banner -->
    <AppDialog
      :show.sync="showEditDialog"
      max-width="700"
      persistent
      icon="mdi-view-carousel"
      title="Edit Banner"
      subtitle="Update this banner's details"
    >
      <BannerEditPage
        v-if="showEditDialog"
        embedded
        :banner-id="editingId"
        @saved="onBannerUpdated"
        @close="showEditDialog = false"
      />
    </AppDialog>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import AppDialog from "@/components/AppDialog.vue";
import BannerCreatePage from "./create.vue";
import BannerEditPage from "./id.vue";
export default {
  name: "bannersPage",
  components: { ConfirmationDialog, AppDialog, BannerCreatePage, BannerEditPage },
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      banners: [],
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      deleteDialog: false,
      pendingDeleteId: null,
      pendingDeleteBanner: null,
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportBannerTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_banner: false,
      is_deleted_banner: false,
      is_restored_banner: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`banners?${query}`)
        .then((response) => {
          this.banners = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      const response = await axios.get(`banner_exports?${query}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `banners_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    askDelete(banner) {
      this.pendingDeleteId = banner.id;
      this.pendingDeleteBanner = banner;
      this.deleteDialog = true;
    },
    onBannerCreated() {
      this.showCreateDialog = false;
      this.page = 1;
      this.getData();
    },
    openEditDialog(banner) {
      this.editingId = this.encryptIt(banner.id);
      this.showEditDialog = true;
    },
    onBannerUpdated() {
      this.showEditDialog = false;
      this.getData();
    },
    async Delete_this(id) {
      this.delete_banner = true;
      await axios
        .post(`/banners/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_banner = true;
          this.deleteDialog = false;
          this.pendingDeleteBanner = null;
          this.getData();
        })
        .catch((error) => {
          console.log(error);
          // // window.location.href = "/auth/login";
        })
        .finally(() => {
          this.delete_banner = false;
        });
    },
    async Restore_this(id) {
      this.restore_banner = true;
      await axios
        .post(`/banners/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_banner = false;
          this.is_restored_banner = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
